//Core
import React, { useState, useEffect, useRef } from "react"

//Components
import InputMask from "react-input-mask"

//Style
import style from "./style.module.scss"

const { Container, Input, Warning, fullWeigth, succes, error } = style

const InputComponents = ({
  title,
  message,
  valid,
  checked,
  change = () => {},
  placeholder,
  full = false,
  haveInitial = true,
  value,
  chakedFunc = () => {},
}) => {
  console.log("haveInitial", haveInitial)
  const [disabled, setDisabled] = useState(haveInitial)

  const refContainer = useRef(null)

  useEffect(() => {
    setDisabled(haveInitial)
    console.log("refContainer", refContainer)

    if (haveInitial && refContainer) {
      if (window) {
        document.getElementById("travelInput").setAttribute("disabled", true)
      }
    }
  }, [haveInitial, refContainer])

  return (
    <div className={[Container, full ? fullWeigth : " "].join(" ")}>
      {title ? <span>{title}</span> : null}
      <InputMask
        className={[
          Input,
          valid ? succes : "",
          checked && !valid ? error : " ",
        ].join(" ")}
        id={"travelInput"}
        ref={refContainer}
        type="tel"
        mask="+38 (099) 999-99-99"
        placeholder={placeholder}
        onChange={({ target: { value } }) => change(value)}
        onBlur={() => chakedFunc()}
        disabled={disabled}
        value={value}
      />

      {checked ? valid ? null : <p className={Warning}>{message}</p> : null}
    </div>
  )
}

export default InputComponents
